import { useEffect, useCallback, useState } from 'react'
import { fetchByPath } from 'src/api/sduiService'
import { UXComponent } from 'src/componentsV2/CoreUX/UXComponentRenderer/uxComponent'

type UseFetchByPathResult = {
  items: UXComponent[] | undefined
  isLoading: boolean
  error: Error | null
}

export const useFetchByPath = (path: string): UseFetchByPathResult => {
  const [items, setItems] = useState<UXComponent[] | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(!!path)
  const [error, setError] = useState<Error | null>(null)

  const fetchItems = useCallback(async () => {
    if (!path) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    setError(null)

    try {
      const response = await fetchByPath(path)
      setItems(response)
    } catch (err) {
      setError(err as Error)
    } finally {
      setIsLoading(false)
    }
  }, [path])

  useEffect(() => {
    fetchItems()
  }, [fetchItems])

  return { items, isLoading, error }
}
